import React from "react";
import Container from "react-bootstrap/Container";

import Header from "../../components/Header/category";
import Content from "../../components/Content/category";
import FAQ from "../../components/Faq";
import InfoBlock from "../../components/Content/infoblock";
import AditionalBlock from "../../components/Content/aditional";
import AdvantagesSection from "../../components/Content/Categories/advantages";
import CheckListSection from "../../components/Content/Categories/checklist_block";
import OurSchoolsBlock from "../../components/Content/our_schools";
import LearningStructure from "../../components/Content/Categories/learning_structure";

const A_KLASSE_STATIC_DATA = {
  slug: "a",
  header: {
    categoryname: "A",
    title: "Führerschein Klasse A1, A2, A80, A",
    description:
      "Mach deinen Motorradführerschein in Bergedorf – für A1, A2, A80, A und B196. Wir begleiten dich von Anfang an mit persönlicher Beratung, praxisnaher Ausbildung und optimaler Vorbereitung auf Theorie- und Praxisprüfung.",
    image: "/a-klasse/a-klasse_header.jpg",
  },
  catinfo: {
    title: "ÜBERBLICK",
    intro: "Hier findest du die wichtigsten Informationen auf einen Blick.",
    thumb: {
      data: {
        attributes: {
          url: "/a-klasse/a-klasse_section_1.jpg",
          localFile: true,
        },
      },
    },
    info: {
      title: "Motorradklassen",
      intro:
        "Hier findest du die wichtigsten Informationen zu den Motorradklassen A1, A2, A80 und A auf einen Blick.",
      thumb: {
        data: {
          attributes: {
            url: "/a-klasse/a-klasse_section_2.jpg",
            localFile: true,
          },
        },
      },
    },
    points: [
      {
        title: "Klassen",
        description:
          "Wir bilden dich für A1, A2, A80 und A aus – je nachdem, welches Motorrad du fahren möchtest.",
      },
      {
        title: "Mindestalter",
        description:
          "A1 ist ab 16 Jahren möglich, A2 ab 18 Jahren, A80 ab 21 Jahren und A ab 24 Jahren. Mit mindestens 2 Jahren A2-Vorbesitz ist der Aufstieg auf A bereits ab 20 Jahren möglich.",
      },
      {
        title: "Theorie und Praxis",
        description:
          "Die Theorie kann kompakt in 7 Tagen absolviert werden. Die praktische Motorrad-Ausbildung planen wir individuell nach deinem Lernstand, deiner Verfügbarkeit und den verfügbaren Prüfungsterminen.",
      },
      {
        title: "Standort",
        description:
          "Beratung ist in allen Filialen möglich. Die Anmeldung für die Motorrad-Ausbildung erfolgt in Bergedorf oder HafenCity, die praktische Ausbildung findet aktuell in Bergedorf statt.",
      },
    ],
    items: [
      {
        id: "class-a1",
        code: "A1",
        title: "Leichtkrafträder bis 125 cm³",
        age: "Mindestalter: 16 Jahre",
        description:
          "Mit der Führerscheinklasse A1 darfst du leichte Motorräder bis 125 cm³ Hubraum und maximal 11 kW Leistung fahren. Der ideale Einstieg für alle, die schon früh mobil auf zwei Rädern unterwegs sein möchten.",
      },
      {
        id: "class-a2",
        code: "A2",
        title: "Motorräder bis 35 kW",
        age: "Mindestalter: 18 Jahre",
        description:
          "Mit der Führerscheinklasse A2 darfst du Motorräder mit einer Leistung von bis zu 35 kW fahren. Perfekt für alle, die nach der Klasse A1 den nächsten Schritt machen oder direkt ab 18 Jahren in die Motorradwelt einsteigen möchten.",
      },
      {
        id: "class-a80",
        code: "A80",
        title: "Klasse A mit Schlüsselzahl 80",
        age: "Mindestalter: 21 Jahre",
        description:
          "Mit der Führerscheinklasse A80 absolvierst du Ausbildung und Prüfung auf einem Motorrad der Klasse A. Bis zum 24. Lebensjahr darfst du Motorräder der Klasse A2 fahren. Ab deinem 24. Geburtstag gilt automatisch die unbeschränkte Klasse A – ganz ohne zusätzliche Prüfung.",
      },
      {
        id: "class-a",
        code: "A",
        title: "Motorräder ohne Leistungsbegrenzung",
        age: "Mindestalter: 24 Jahre oder ab 20 Jahren mit mindestens 2 Jahren Vorbesitz der Klasse A2",
        description:
          "Mit der Führerscheinklasse A darfst du alle Motorräder ohne Leistungsbegrenzung fahren. Der Direkteinstieg ist ab 24 Jahren möglich. Wer die Klasse A2 bereits seit mindestens zwei Jahren besitzt, kann schon ab 20 Jahren auf die Klasse A aufsteigen.",
      },
      {
        id: "class-b196",
        code: "B196",
        title: "125er fahren mit der Klasse B",
        // age: "Mindestalter: ab 25 Jahren",
        description:
          "Mit der Erweiterung B196 dürfen Inhaber der Führerscheinklasse B Leichtkrafträder bis 125 cm³ und 11 kW fahren – ohne Prüfung. Voraussetzung sind ein Mindestalter von 25 Jahren sowie mindestens fünf Jahre Besitz der Klasse B. Statt einer theoretischen oder praktischen Prüfung ist lediglich eine Fahrerschulung mit 4 Theorie- und 5 Praxiseinheiten à 90 Minuten erforderlich. Nach erfolgreicher Teilnahme wird die Schlüsselzahl 196 in den Führerschein eingetragen. Die Erweiterung gilt nur in Deutschland.",
      },
    ],
  },
  infoblock: {
    title:
      "Beratung in allen Filialen – Ausbildung findet jedoch in Bergedorf statt.",
    description:
      "Du interessierst dich für den Motorradführerschein? Dann besuche uns gerne in einer unserer Filialen für eine persönliche Beratung. Anmeldungen für die Motorradausbildung nehmen wir in Bergedorf und in der HafenCity entgegen. Die Motorradausbildung selbst bieten wir aktuell ausschließlich in Bergedorf an.",
    form: true,
  },
  ourSchools: true,
  advantages: {
    title: "Deine Vorteile",
    intro:
      "Dein Motorradführerschein in Bergedorf – klar geplant, persönlich begleitet und Schritt für Schritt bis zur Prüfung.",
    advantages: [
      {
        title: "7 Tage Theorie",
        description: "Kompakt, planbar und klar strukturiert.",
      },
      {
        title: "Schnelle Prüfungstermine",
        description: "Wir planen Theorie und Praxis so direkt wie möglich.",
      },
      {
        title: "Kurze Wartezeiten",
        description: "Damit du ohne unnötige Pausen vorankommst.",
      },
    ],
  },
  learning_structure: {
    theorie: {
      title: "Theorie",
      // intro: "Theorie für deinen Motorradführerschein",
      // description:
      //   "In der Theorie lernst du die wichtigsten Regeln, Verkehrszeichen und Verkehrssituationen kennen. So bereitest du dich gezielt auf die Prüfung und sicheres Fahren im Alltag vor.",
      items: [
        {
          title: "Ersterwerb",
          description: `
Wenn du noch keinen Führerschein besitzt, umfasst die theoretische Ausbildung:
- ⁠6 Doppelstunden Grundstoff (je 90 Minuten)
- ⁠zusätzlich 2 Doppelstunden Motorrad-spezifischer Unterricht (je 90 Minuten) für die Klassen A1, A2, A80 und A
            `,
        },
        {
          title: "Erweiterung",
          description: `
Wenn du bereits einen Führerschein besitzt, reduziert sich der Grundstoff:
- ⁠3 Doppelstunden Grundstoff (je 90 Minuten)
- ⁠zusätzlich 2 weitere Doppelstunden Grundstoff (je 90 Minuten)
            `,
        },
        {
          title: "Aufstieg ohne Theorieprüfung",
          description:
            "Wenn du die Klasse A1 oder A2 seit mindestens zwei Jahren besitzt, ist beim Aufstieg in die nächsthöhere Motorradklasse kein Theorieunterricht erforderlich. Die Vorbereitung konzentriert sich in diesem Fall ausschließlich auf die praktische Ausbildung und Prüfung.",
        },
        {
          title: "THEORIEPRÜFUNG",
          description:
            "Im Theorieunterricht sowie mit begleitendem Lernmaterial wirst du gezielt auf die theoretische Prüfung vorbereitet. Sobald du ausreichend vorbereitet bist, erfolgt in Abstimmung mit deiner Fahrschule die Anmeldung zur Prüfung.",
        },
      ],
    },
    praxis: {
      title: "Praxis",
      // intro: "Praxis und Sonderfahrten",
      // description:
      //   "In der praktischen Ausbildung lernst du Schritt für Schritt, ein Motorrad sicher, kontrolliert und verantwortungsbewusst zu führen. Die Anzahl der Übungsstunden ist dabei individuell und richtet sich nach deinem persönlichen Lernfortschritt. Es gilt: so wenige Fahrstunden wie möglich, aber so viele wie nötig, um dich optimal auf die sichere Teilnahme am Straßenverkehr vorzubereiten.",
      items: [
        {
          title: "Individuelle Übungsstunden",
          description:
            "Die regulären Übungsstunden sind nicht fest vorgeschrieben und werden flexibel an deinen Ausbildungsstand angepasst.",
        },
        {
          title: "Sonderfahrten – Ersterteilung (A1/A2/A80/A)",
          description: `
Im Rahmen der Ersterteilung sind insgesamt 12 Sonderfahrten vorgeschrieben:
- ⁠5 Überlandfahrten
- 4 Autobahnfahrten
- ⁠3 Fahrten bei Dämmerung oder in der Nacht
            `,
        },
        {
          title: "Sonderfahrten – Erweiterung (Aufstieg)",
          description: `
Bei einer Erweiterung sind insgesamt 6 Sonderfahrten erforderlich:
- ⁠3 Überlandfahrten
- ⁠2 Autobahnfahrten
- ⁠1 Fahrt bei Dämmerung oder in der Nacht
            `,
        },
        {
          description:
            "Diese Sonderfahrten dienen dazu, dich gezielt auf besondere Verkehrssituationen vorzubereiten und deine Fahrkompetenz unter anspruchsvolleren Bedingungen zu festigen.",
        },
      ],
    },
  },
  checklist: {
    title: "CHECKLISTE FÜR DEINEN START",
    description:
      "Damit dein Start reibungslos läuft, klären wir gemeinsam, was vor der Anmeldung wichtig ist und was du zu den ersten Fahrstunden brauchst.",
    items: [
      {
        text: "Mindestalter je nach Klasse",
      },
      {
        text: "Gültiger Ausweis",
      },
      {
        text: "Biometrisches Passfoto",
      },
      {
        text: "Sehtest",
      },
      {
        text: "Erste-Hilfe-Kurs",
      },
      {
        text: "Falls vorhanden: aktueller Führerschein",
      },
      {
        text: "Motorrad-Schutzkleidung für die Fahrstunden",
      },
    ],
  },
  faq: {
    title: "Klasse A",
    qa: [
      {
        id: "a-1",
        question: "Welche Motorradklassen bietet ihr an?",
        answer:
          "Wir bilden für die Klassen A1, A2 und A aus. A1 ist für leichte Motorräder bis 125 cm³, A2 für Motorräder bis 35 kW und A für Motorräder ohne Leistungsbegrenzung.",
      },
      {
        id: "a-2",
        question: "Ab welchem Alter kann ich den Motorradführerschein machen?",
        answer:
          "A1 ist ab 16 Jahren möglich, A2 ab 18 Jahren und A ab 24 Jahren beim Direkteinstieg. Wenn du mindestens 2 Jahre A2 besitzt, kannst du Klasse A bereits ab 20 Jahren machen.",
      },
      {
        id: "a-3",
        question: "Wo findet die Motorrad-Ausbildung statt?",
        answer:
          "Die praktische Motorrad-Ausbildung findet aktuell in Bergedorf statt. Beratung und Anmeldung sind aber in allen Filialen möglich.",
      },
      {
        id: "a-4",
        question: "Kann ich mich auch in HafenCity oder Geesthacht anmelden?",
        answer:
          "Ja. Du kannst dich in jeder Filiale beraten lassen. Für die Anmeldung und Motorrad-Ausbildung wirst du anschließend nach Bergedorf weitergeleitet.",
      },
      {
        id: "a-5",
        question: "Wie lange dauert die Ausbildung?",
        answer:
          "Die Theorie ist im Intensivformat in 7 Tagen möglich. Die praktische Ausbildung ist auf 14 Tage ausgelegt, abhängig von deinem Fortschritt und deiner Verfügbarkeit.",
      },
      {
        id: "a-6",
        question: "Wie viele Theoriestunden brauche ich?",
        answer:
          "Beim Ersterwerb brauchst du 12 Grundstoff-Doppelstunden à 90 Minuten. Wenn du bereits einen Führerschein besitzt, brauchst du 6 Grundstoff-Doppelstunden. Zusätzlich kommen 4 Motorrad-Doppelstunden dazu.",
      },
      {
        id: "a-7",
        question:
          "Muss ich beim Aufstieg von A1 auf A2 oder von A2 auf A wieder Theorie machen?",
        answer:
          "Wenn du die vorherige Motorradklasse seit mindestens 2 Jahren besitzt, entfällt die Theorieprüfung. Dann ist nur die praktische Prüfung notwendig.",
      },
      {
        id: "a-8",
        question: "Wie viele Pflichtfahrten brauche ich?",
        answer:
          "Für A1, A2 und A sind 12 Sonderfahrten à 45 Minuten vorgeschrieben: 5 Überlandfahrten, 4 Autobahnfahrten und 3 Nacht- bzw. Dämmerungsfahrten.",
      },
      {
        id: "a-9",
        question: "Wie viele normale Fahrstunden brauche ich?",
        answer:
          "Die normalen Übungsstunden sind nicht fest vorgeschrieben. Die Anzahl hängt davon ab, wie sicher du fährst und wie schnell du prüfungsreif bist.",
      },
      {
        id: "a-10",
        question: "Was muss ich zur Anmeldung mitbringen?",
        answer:
          "Du brauchst einen gültigen Ausweis, ein biometrisches Passfoto, einen Sehtest, einen Erste-Hilfe-Nachweis und, falls vorhanden, deinen aktuellen Führerschein. Für die Fahrstunden brauchst du außerdem geeignete Motorrad-Schutzkleidung.",
      },
    ],
  },
};

const CategoryA = () => {
  const category = A_KLASSE_STATIC_DATA;

  return (
    <>
      <header className="layout layout__small layout__bg layout__bg_primary position-relative overflow-hidden">
        <Container fluid>
          <Header props={category.header} newform={true}></Header>
        </Container>
      </header>
      <main className="layout layout__main">
        {category.slug === "erste-hilfe" && category.promo && (
          <AditionalBlock aditional={category.promo} newform={false} />
        )}

        <section
          className={`layout__color_primary position-relative ${
            !category.infoblock ? "pb-0" : ""
          }`}
        >
          <Container fluid className="layout__main">
            <Content
              obj={category.catinfo}
              catname={category.header.categoryname}
            ></Content>
          </Container>
        </section>

        {category.infoblock && (
          <section className="layout layout__bg layout__bg_primary">
            <InfoBlock element={category.infoblock} />
          </section>
        )}

        {category.ourSchools && <OurSchoolsBlock />}

        {category.advantages && (
          <AdvantagesSection element={category.advantages} />
        )}

        {category.learning_structure && (
          <LearningStructure element={category.learning_structure} />
        )}

        {category.checklist && (
          <section className="layout layout__bg layout__bg_primary">
            <CheckListSection element={category.checklist} />
          </section>
        )}

        <section className="layout__color_primary">
          <Container fluid>
            <h2 data-aos="fade-up" className="">
              FAQ - {category.faq.title}
            </h2>
            <FAQ elements={category.faq.qa} newform={true} />
          </Container>
        </section>
      </main>
    </>
  );
};

export default CategoryA;
